import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37d513d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-center layout-backtop" }
const _hoisted_2 = { class: "layout-parent" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "layout-footer pb15",
  style: {"font-size":"12px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "layout-footer-warp" }, [
    /*#__PURE__*/_createElementVNode("div", null, "旺盈集团合同管理系统 Ver 2.0.0"),
    /*#__PURE__*/_createElementVNode("div", { class: "mt5" }, "Copyright © 2023 Voion All rights reserved.")
  ])
], -1))

import { reactive, onBeforeMount } from 'vue';
import { useKeepALiveNames } from '@/store/useKeepALiveNames';
import { storeToRefs } from 'pinia';

import LayoutHeaders from './components/headerbar.vue';
import LayoutSidebar from './components/sidebar.vue';
// import Menu from './components/menu.vue';
// import GbTabsBar from './components/tabsbar.vue';
// import GbNavigation from './components/navigation.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const storesKeepAliveNames = useKeepALiveNames();
const { cachedViews } = storeToRefs(storesKeepAliveNames);

const state = reactive<any>({
	keepAliveNameList: [],
	refreshRouterViewKey: '',
});

onBeforeMount(() => {
	state.keepAliveNameList = cachedViews.value;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "layout-container flex-center" }, {
    default: _withCtx(() => [
      _createVNode(LayoutHeaders),
      _createVNode(_component_el_container, { class: "layout-mian-height-50" }, {
        default: _withCtx(() => [
          _createVNode(LayoutSidebar),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_main, {
              class: "layout-main",
              style: {"minheight":"calc(100% - 50px)"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_scrollbar, {
                  ref: "layoutMainScrollbarRef",
                  class: "layout-main-scroll layout-backtop-header-fixed",
                  "wrap-class": "layout-main-scroll",
                  "view-class": "layout-main-scroll"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_router_view, null, {
                        default: _withCtx(({ Component }) => [
                          (_openBlock(), _createBlock(_KeepAlive, {
                            include: _unref(state).keepAliveNameList
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                              key: _unref(state).refreshRouterViewKey,
                              style: {"width":"100%"}
                            }))
                          ], 1032, ["include"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_3
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})